// extracted by mini-css-extract-plugin
export var container = "styles-module--container--Ex4ha";
export var sliderWrapper = "styles-module--sliderWrapper--3ulJg";